import React from 'react';
import Navbar from 'react-bootstrap/Navbar';
import Nav from 'react-bootstrap/Nav';


//import LoginPage from './LoginPage.js'
//import {resourceEndpoint} from './config';
//import {useTranslation} from 'react-i18next'

function Footer(props) {
  return (
  <Navbar className="footer" expand="lg" style={{"zIndex": "1"}}>
    <Navbar.Toggle aria-controls="basic-navbar-nav" />
    <Navbar.Collapse id="basic-navbar-nav">

    <Nav style={{"display": "flex", "justifyContent": "space-around", "width": "100%"}}>
      {props.memberSupport && <Nav.Link href={props.memberSupport.url}>{props.memberSupport.title} (SCTA Supporting Member)</Nav.Link>}
      <Nav.Link href="https://scta.info">Powered by SCTA Data</Nav.Link>
      <Nav.Link href="https://lombardpress.org">A LombardPress Viewer</Nav.Link>
      <Nav.Link href="https://jeffreycwitt.com">Designed by Jeffrey C Witt</Nav.Link>
      
    </Nav>
    
    </Navbar.Collapse>

    </Navbar>)
}

export default Footer;